<script setup lang="ts">
import { Alert } from '@/shared/ui/Alert'
import { Button } from '@/shared/ui/Button'
import { Inline } from '@/shared/ui/Inline'
import { Stack } from '@/shared/ui/Stack'

/**
 * What a panel, card or chart draws instead of its content when the request behind it was
 * refused: the server's sentence and a "Try again". A table does not need it — `Table` says
 * the same by itself — and an edit modal passes `load-error` to `FormModal` instead.
 *
 * `message` is `recordLoadError(...)` from the slice's model; render this only while it is set.
 * Pass the query's `isFetching` as `retrying`: a refetch after an error leaves `isLoading`
 * false, so nothing else on screen shows that "Try again" did anything.
 */
defineProps<{
  message: string
  retrying?: boolean
}>()

const emit = defineEmits<{
  (e: 'retry'): void
}>()
</script>

<template>
  <Stack>
    <Alert type="error">{{ message }}</Alert>
    <Inline>
      <Button
        type="primary"
        size="small"
        :loading="retrying"
        @click="emit('retry')"
      >
        Try again
      </Button>
    </Inline>
  </Stack>
</template>
